import Images from '../../common/Images'
import './Home.css'

import { useInView } from 'react-intersection-observer'
import MotionBloodCell from './MotionBloodCell'
import HomeLinks from '../../common/HomeLinks'

function Home () {
  const options = {
    threshold: 0.2,
    triggerOnce: true
  }
  const [ref5, inView5] = useInView(options)
  const [ref6, inView6] = useInView(options)
  const [ref7, inView7] = useInView(options)

  return (
    <div className="home-mainContainer">
      <MotionBloodCell />
      <div
        ref={ref5}
        className={`home-block1 home-block ${
          inView5 ? 'home-block-show' : 'home-block-hide'
        }`}
      >
        <div>
          <p>
            Blood donations are restricted by two central systems: the ABO
            system and the Rh system. The <b>ABO system</b> consists of two
            kinds of antigens that can be present on red blood cells: A and B.
            Both these antigens can be present (designating the blood type as
            AB) or absent (designating the blood type as O for absence of
            antigens).
          </p>
          <p>
            The <b>Rh system</b> represents the presence or absence of the Rh
            protein complex in the membranes of red blood cells. When the
            protein is present, the blood group is positive (+), and negative
            (-) when it is absent.
          </p>
        </div>
        <img className="home-cells-group" src={Images.GroupOfCells} />
        <img className="home-cells-hori" src={Images.GroupOfCellsHorizontal} />
      </div>
      <div
        ref={ref6}
        className={`home-block2 home-block ${
          inView6 ? 'home-block-show' : 'home-block-hide'
        }`}
      >
        <div>
          <b>What if blood donations didn&apos;t have to be so complex?</b>
        </div>
        <div>
          What if we could transform every blood type to O-, which can be given
          to anyone? That’s where we come in, with the{' '}
          <b>
            <i>Blood Cell Barber Shop</i>
          </b>
          !
        </div>
      </div>
      <div
        ref={ref7}
        className={`home-block3 home-block ${
          inView7 ? 'home-block-show' : 'home-block-hide'
        }`}
      >
        <p>
          This year, our iGEM team worked on converting <b>any type of blood</b>{' '}
          into O- blood, the universal donor. <br /> <br /> Our novel work based
          on using enzymes to give the blood cells a “haircut” aims to pave the
          way for a future where blood banks never run out of blood!
        </p>
        <img
          className="home-logo-low"
          src={Images.LogoBloodCellBarberShopBlack}
        />
      </div>
      <div className="home-links-container">
        <span>
          <b>Take a look at these pages to get to know our project better!</b>
        </span>
        <div className="home-links">
          {HomeLinks.map((homeLink, idx) => (
            <a href={homeLink.link} className="home-link" key={idx}>
              <div className="home-link-icon">
                <img srcSet={homeLink.icon} alt="" />
              </div>
              <div className="home-link-description">
                <span>{homeLink.title}</span>
                <span>{homeLink.description}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Home
